export default class Loggone {
	static reset() {
		Loggone.buffer = "";
	}

	static log(value, lNoBr = false) {
		Loggone.buffer += value;
		if (!lNoBr) {
			Loggone.buffer += "\n";
		}
	}
	static show() {
		console.log(Loggone.buffer);
	}

}
Loggone.buffer = "";